import React from 'react';
import PropTypes from 'prop-types';
import css from './Dicon.module.less';

const Dicon = ({
  name,
  theme = 'light',
  size = 'sm',
  className = '',
  ...otherProps
}) => {
  const classes = [css.dicon, css[theme], css[size], className];

  return (
    <svg className={classes.join(' ')} {...otherProps}>
      <use xlinkHref={'#dicon-' + name} />
    </svg>
  );
};

Dicon.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'dark', 'yellow', 'red', 'orange']),
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  className: PropTypes.string,
};

export default Dicon;
